const state = () => ({
  isNPSCardClicked: false
})

const mutations = {
  set(state, { type, payload }) {
    state[type] = payload
  },
}

export { state, mutations }
